import { Theme } from '@mui/material/styles'
import { MixinsOptions } from '@mui/material/styles/createMixins'

export default function Mixins(theme: Theme): MixinsOptions {
  return {}
}
